import { html, raw } from '../lib/html.js';
import { onlyDigits } from '../lib/masks.js';
import { autoClearErrors, busy, setFieldError, toastError, toastSuccess, valueOf } from '../lib/ui.js';
import { flow } from '../lib/flow.js';
import { auth } from '../services/auth.js';
import { session } from '../services/session.js';
import { Page, brand, go } from './base.js';

class ConfirmPage extends Page {
  template() {
    return html`
      <ion-header class="ion-no-border">
        <ion-toolbar>
          <ion-buttons slot="start"><ion-back-button default-href="/login" text="Voltar"></ion-back-button></ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding auth">
        <div class="auth-wrap">
          ${raw(brand('Confirme seu e-mail'))}
          <p class="hint">Enviamos um código de 6 dígitos para <strong class="email"></strong>.</p>
          <form novalidate>
            <ion-list lines="none" class="form">
              <ion-input name="code" label="Código" label-placement="floating" fill="outline" inputmode="numeric"
                autocomplete="one-time-code" maxlength="6" class="code-input"></ion-input>
            </ion-list>
            <ion-button type="submit" expand="block" class="submit">Confirmar</ion-button>
          </form>
          <ion-button fill="clear" expand="block" size="small" class="resend">Reenviar código</ion-button>
        </div>
      </ion-content>`;
  }

  setup() {
    autoClearErrors(this);
    this.$('form').addEventListener('submit', (e) => {
      e.preventDefault();
      this.submit();
    });
    this.$('.resend').addEventListener('click', () => this.resend());
  }

  onEnter() {
    if (!flow.email) return go('/login', 'root');
    this.$('.email').textContent = flow.email;
  }

  async resend() {
    await busy(this.$('.resend'), async () => {
      try {
        await auth.resendCode(flow.email);
        toastSuccess('Código reenviado.');
      } catch (err) {
        toastError(err.message);
      }
    });
  }

  async submit() {
    const code = onlyDigits(valueOf(this, 'code'));
    if (code.length !== 6) return setFieldError(this.$('ion-input[name="code"]'), 'Digite os 6 dígitos');

    await busy(this.$('.submit'), async () => {
      try {
        await auth.confirmSignUp(flow.email, code);
      } catch (err) {
        return setFieldError(this.$('ion-input[name="code"]'), err.message);
      }

      // Se a senha ainda está em memória (veio do cadastro), já entra.
      if (flow.password) {
        try {
          await session.signIn(flow.email, flow.password);
          flow.clear();
          return go('/home', 'root');
        } catch {
          /* segue para o login manual */
        }
      }
      toastSuccess('E-mail confirmado. Entre com sua senha.');
      flow.password = null;
      go('/login', 'root');
    });
  }
}

customElements.define('page-confirm', ConfirmPage);
